import api from './api';
import Step, { StepInterface } from './step';

export interface OrderFlowInterface {
    id: number;
    name: string;
    steps: Step[];
}

export default class OrderFlow implements OrderFlowInterface {
    id: number;
    name: string;
    steps: Step[];

    constructor(orderFlow: OrderFlowInterface) {
        this.id = orderFlow.id;
        this.name = orderFlow.name;
        this.steps = orderFlow.steps;
    }

    static async all(): Promise<OrderFlow[]> {
        const response = await api.get<OrderFlowInterface[]>({ name: 'order_flow.index' });
        if (response.success) {
            return OrderFlow.createBatch(<OrderFlowInterface[]>response.content);
        }
        return [];
    }

    static createBatch(orderFlows: OrderFlowInterface[]): OrderFlow[] {
        let orderFlowInstances = [];
        for (let orderFlow of orderFlows) {
            orderFlowInstances.push(new OrderFlow(orderFlow));
        }
        return orderFlowInstances;
    }

    public static find(id: number): Promise<OrderFlow | null> {
        return new Promise((resolve, reject) => {
            api.get<OrderFlowInterface>({ name: 'order_flow.show', parameters: { id } })
                .then((response) => {
                    if (response.success) {
                        resolve(new OrderFlow(response.content as OrderFlowInterface));
                    } else {
                        resolve(null);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}
